// 埋点事件
export const PubFinEventId = {
    // 技术通用
    // 通用健康度检测埋点
    pub_fintech_fe_page_ck: 'pub_fintech_fe_page_ck',
    pub_fintech_fe_page_sw: 'pub_fintech_fe_page_sw',
    pub_fintech_fe_duration_bt: 'pub_fintech_fe_duration_bt',
    pub_fintech_fe_page_typ: 'pub_fintech_fe_page_typ',

    // 业务通用点位，全链路大盘消费
    fin_outcast_web_common_static_sw: 'fin_outcast_web_common_static_sw', // 通用页面曝光
    fin_outcast_web_common_static_middle_ck: 'fin_outcast_web_common_static_middle_ck', // 中间点击，有中间流程的埋点埋
    fin_outcast_web_common_static_final_ck: 'fin_outcast_web_common_static_final_ck', // 最终点击
};

export const PubFinEventDurationId = {
    '3s_remain': '3s_remain',
    '5s_remain': '5s_remain',
    '8s_remain': '8s_remain',
    'load': 'load',
    'DOMContentLoaded': 'DOMContentLoaded',
    'fmp': 'fmp',
};

export const PubFinPageSwId = {
    // 贷款计算器
    // pageshow
    loansimulator: 'waitou_loansimulationcalculator',
    // 跳转app下载成功后显示
    loansimulator_apply_success: 'waitou_loansimulationcalculator_apply_success',

    // Advertising
    loanadvertising: 'waitou_loanadvertising',

    // 预估额度
    // pageshow
    loanestimatedamount: 'waitou_loanestimatedamount',
    // 跳转app下载成功后显示
    loanestimatedamount_apply_success: 'waitou_loanestimatedamount_apply_success',

};

export const PubFinBtnId = {
    // 贷款计算器
    // 申请贷款
    loan_apply_loan: 'loansimulator_apply_loan',
    // amount滑块变动
    loan_amount_slider_change: 'loan_amount_slider_change',
    // time滑块变动
    loan_time_slider_change: 'loan_amount_slider_change',
    // time checkbox 变动
    loan_time_checkbox_change: 'loan_time_checkbox_change',

    // Advertising
    loanadvertising_curp_input: 'loanadvertising_curp_input',
    loanadvertising_curp_check: 'loanadvertising_curp_check',
    loanadvertising_curp_term: 'loanadvertising_curp_term',
    loanadvertising_curp_confirm: 'loanadvertising_curp_confirm',
    loanadvertising_curp_question: 'loanadvertising_curp_question',
    loanadvertising_phone_input: 'loanadvertising_phone_input',
    loanadvertising_phone_confirm: 'loanadvertising_phone_confirm',
    loanadvertising_code: 'loanadvertising_code',
    loanadvertising_code_confirm: 'loanadvertising_code_confirm',
    loanadvertising_close: 'loanadvertising_close',
    jump_apply_link: 'jump_apply_link',

    // 预估额度
    // 预估额度申请
    loan_apply_loan_estimated: 'loan_estimated_amount_apply_loan',
    // 预估额度弹窗曝光
    loan_apply_loan_estimated_popup_show: 'loan_apply_loan_estimated_popup_show',
    // APP跳转
    loan_apply_loan_estimated_app: 'loan_apply_loan_estimated_app',
    // 首页app跳转
    loan_app_jump: 'loan_app_jump',
    // 学历滑块滑动
    loan_education_slider_change: 'loan_education_slider_change',
    // 工资滑块滑动
    loan_income_slider_change: 'loan_income_slider_change',
    // 信用卡额度滑块滑动
    loan_time_creditlimit_change: 'loan_creditlimit_slider_change',
    // 有信用卡checkbox
    loan_has_creditcard_checkbox_change: 'loan_has_creditcard_checkbox_change',
    // 无信用卡checkbox
    loan_no_creditcard_checkbox_change: 'loan_no_creditcard_checkbox_change',

};

export const PubFinPageSourceId: Record<string, string> = {
    loanSimulationCalculator: 'loanSimulationCalculator',
    getEstimatedByCURP: 'getEstimatedByCURP',
    activityDifferentTerminalsByMobile: 'activityDifferentTerminalsByMobile',
    wakeUpAppWithDeepLink: 'wakeUpAppWithDeepLink',
    loanEstimatedAmount: 'loanEstimatedAmount',
    default: 'Default'
};

export const TechPerformanceId = {
    TECH_PERFORMANCE_ERROR_TYPE: 'tech_performance_error_type',
};

export const TechPerformanceErrorType = {
    'p2_not_init': 'p2_not_init',
    'p3_not_init': 'p3_not_init',
    'p4_direct_not_init': 'p4_direct_not_init',
    'p2_catch_error': 'p2_catch_error',
    'p3_catch_error': 'p3_catch_error',
    'p4_direct_catch_error': 'p4_direct_catch_error',
};
